import { Card, Badge, ProgressBar } from "react-bootstrap";
import { Clock, Repeat } from "react-feather";

const CustomerInsightCard = ({ data, selected, onSelect }) => {
  const {
    customer_name,
    total_spent,
    last_order_days,
    days_to_reorder,
    avg_interval,
    behavior_label,
    action,
    type,
    potential_value,
  } = data;

  const getBehaviorColor = (type) => {
    switch (type) {
      case "active":
        return "bg-success-subtle text-success";
      case "cooling":
        return "bg-warning-subtle text-warning0";
      case "lost":
        return "bg-danger-subtle text-danger";
      case "new":
        return "bg-primary-subtle text-primary";
      default:
        return "bg-light text-white";
    }
  };
  // Safe parsing
  const spent = parseFloat(total_spent || 0);
  const reorderDays = parseFloat(days_to_reorder ?? 0);

  const isOverdue = reorderDays < 0;

  // Progress logic
  const progress = Math.min(
    Math.max(100 - Math.abs(reorderDays * 10), 5),
    100
  );

  return (
    <div className="col-12 col-m-6 col-lg-6">
      <Card className="shadow-tile border-dlblue border-0 rounded-4 p-3 mb-0">

        {/* TOP: tags + menu */}
        <div className="text-right mb-2">

          <Badge
            className={`px-2 py-1 border-0 font8-bdg ${getBehaviorColor(type)}`}
          >
            {behavior_label || "Customer"}
          </Badge>
          {type !== "lost" && <>
                <Badge
                  className={`px-2 py-1 border-0 font8-bdg ms-2 ${
                    isOverdue ? "bg-danger-subtle text-danger" : "bg-warning-subtle  text-warning0"
                  }`}
                >
                  {isOverdue ? "Overdue" : "Upcoming"}
                </Badge>
          </>}
        </div>

        {/* TITLE */}
        <div className="fw-semibold mb-1">
          <div
            className="rounded-3 d-flex align-items-center justify-content-center me-2 mt-1"
            style={{
              width: "40px",
              height: "40px",
              background: "#6f42c1",
              color: "#fff",
              fontSize: "13px",
              fontWeight: "bold",
              float:"left",
            }}
          >
            {customer_name?.charAt(0) || "C"}
          </div><p className="mb-0 p-0">{customer_name}</p>
          <div className="text-muted font8 mb-2 d-flex align-items-center flex-wrap gap-2">
    
            <span className="d-flex align-items-center gap-1">
              <Clock size={14} />
              <span>
                {last_order_days}d ago
              </span>
            </span>

            <span>•</span>

            <span className="d-flex align-items-center gap-1">
              <Repeat size={14} />
              <span>
                {avg_interval || "0"}d cycle
              </span>
            </span>

          </div>
        </div>

         {/* SUBTASK / PROGRESS HEADER */}
        <div className="d-flex justify-content-between align-items-center mb-1">
          <small className="fw-medium font8">Reorder timing</small>
          <small className="text-muted font8">
            {isOverdue
              ? `${Math.round(Math.abs(reorderDays))}d overdue`
              : `${Math.round(reorderDays)}d`}
          </small>
        </div>

        {/* PROGRESS BAR */}
        <ProgressBar
          now={progress}
          className={`mb-3 ${
            isOverdue ? "bg-danger" : "bg-warning"
          }`}
          style={{ height: "6px", borderRadius: "6px" }}
        />

        {/* ACTION MESSAGE */}
        {action?.message && (
          <div className="mb-3">
            
            {/* Label */}
            <div className="text-muted font7 mb-1 d-flex align-items-center gap-1">
              <span>✨</span> Suggested Message
            </div>

            {/* Card */}
            <div
              className="p-2 rounded-3 border font8"
              style={{
                background: "#f8f9fb",
                lineHeight: "1.4",
                color: "#333",
              }}
            >
              {action.message}
            </div>
          </div>
        )}

       

        {/* FOOTER */}
        <div className="d-flex justify-content-between align-items-center mt-2 pt-2 border-top">

        {/* LEFT: value */}
        <div className="text-muted font8-bdg">
          <span className="fw-semibold">KES {potential_value.toLocaleString()}</span>
          <span className="ms-1">potential</span>
        </div>

        {/* RIGHT: action selector */}
        <div
          className={`d-flex align-items-center gap-2 px-2 py-1 ${
            selected ? "bg-primary br-10 text-white" : ""
          }`}
          style={{ cursor: "pointer" }}
          onClick={onSelect}
        >
          <input
            type="checkbox"
            className="form-check-input m-0 custom-checkbox-nm"
            checked={selected || false}
            onChange={onSelect}
            onClick={(e) => e.stopPropagation()} // prevent double toggle
          />

          <span
            className={`small ${
              selected ? "fw-semibold font8-bdg" : "text-muted"
            }`}
          >
            {selected ? "Selected" : "Send Message"}
          </span>
        </div>
      </div>
      </Card>
    </div>
  );
};

export default CustomerInsightCard;